import useAPI from '@/hooks/useAPI';
import PersonStaffRelationshipRepository from '@/repositories/PersonStaffRelationshipRepository';
import { QueryParams } from '@/types/query';

export const usePersonStaffRelationships = (params: QueryParams) => {
  const personStaffRelationshipsRepository = PersonStaffRelationshipRepository();

  return useAPI({
    queryKey: ['getPersonStaffRelationships', params],
    queryFn: () => personStaffRelationshipsRepository.getPersonStaffRelationships(params),
    enabled: !!params
  });
};

export const usePersonStaffRelationshipTypes = (enabled = true) => {
  const personStaffRelationshipsRepository = PersonStaffRelationshipRepository();

  return useAPI({
    queryKey: ['getPersonStaffRelationshipTypes'],
    queryFn: () => personStaffRelationshipsRepository.getPersonStaffRelationshipTypes(),
    enabled
  });
};
